import Api from './Api'

class FailedLabelsService {
  /**
   * Get paginated list of orders with failed labels
   * @param {Object} params - Query parameters
   * @param {number} params.limit - Number of items per page
   * @param {number} params.offset - Number of items to skip
   * @param {string} params.startDate - Filter by start date
   * @param {string} params.endDate - Filter by end date
   * @param {string} params.sortBy - Sort field
   * @param {string} params.sortOrder - Sort order (asc/desc)
   * @returns {Promise} API response
   */
  static async getFailedLabels(params = {}) {
    return Api().get('/orders/failed-labels', { params })
  }

  /**
   * Get detailed information for a specific failed label order
   * @param {string} orderId - The order ID
   * @returns {Promise} API response with order details
   */
  static async getFailedLabelDetails(orderId) {
    return Api().get(`/orders/failed-labels/${encodeURIComponent(orderId)}`)
  }

  /**
   * Retry label creation for a specific order
   * @param {string} orderId - The order ID
   * @param {Object} options - Retry options
   * @param {Object} options.addressOverride - Optional address override
   * @param {number} options.shippingProfileId - Optional shipping profile ID
   * @param {boolean|null} options.under3cm - Package size (null for auto-detect)
   * @returns {Promise} API response
   */
  static async retryLabelCreation(orderId, options = {}) {
    return Api().post(`/orders/failed-labels/${encodeURIComponent(orderId)}/retry`, options)
  }

  /**
   * Get available shipping profiles
   * @returns {Promise} API response with shipping profiles
   */
  static async getShippingProfiles() {
    return Api().get('/shipping-profiles')
  }
}

export default FailedLabelsService